import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';

import App from './App';

const render = () => {
  const rootNode = document.getElementById('root');
  if (!rootNode) {
    throw new Error('Root element is not provided');
  }

  const root = createRoot(rootNode);

  root.render(
    <StrictMode>
      <ErrorBoundary fallback={<p>⚠️Something went wrong</p>}>
        <App />
      </ErrorBoundary>
    </StrictMode>
  );
};

if (window.document.readyState === 'complete') {
  render();
} else {
  window.addEventListener('load', () => {
    render();
  });
}

export default {};
